module.exports = __webpack_public_path__ + "img/icon_map_108_off_001.5b673ffe.png";